// These functions work with CSS custom properties (variables)
// Use instead of polished package

export function rgba(color, amount) {
    return `rgb(from ${color} r g b / ${amount})`;
}

export function tint(amount, color) {
    return `color-mix(in srgb, ${color}, white calc(100% * ${amount}))`;
}
